import { createSelector } from '@ngrx/store';

import { getFeatureToggleState } from '../../reducers';

export const selectBeneByRelationToggleState = createSelector(
  getFeatureToggleState,
  (state) => state.benes_by_relation,
);
export const selectControlPersonFeatureToggle = createSelector(
  getFeatureToggleState,
  (state) => state.control_person,
);
export const selectGiftingToggle = createSelector(getFeatureToggleState, (state) => state.gifting);
export const selectGiftingScaleToggleV2 = createSelector(
  getFeatureToggleState,
  (state) => state.gifting_scale_v2,
);
export const selectInheritedTraditionalIRAToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_trad,
);
export const selectInheritedRothIRAToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_inh_roth,
);
export const selectIRAEstateToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_estate,
);
export const selectIRAInheritedRothToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_inh_roth,
);
export const selectIRAInheritedTraditionalToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_trad,
);
export const selectIRATrustToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_trust,
);
export const selectInheritanceIRAQuestionToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_ira_question,
);
export const selectInheritanceJoint = createSelector(
  getFeatureToggleState,
  (state) => state.joint_inheritance,
);
export const selectInheritanceIndividual = createSelector(
  getFeatureToggleState,
  (state) => state.inheritance_individual,
);
export const selectInheritanceIRA = createSelector(
  getFeatureToggleState,
  (state) => state.inheritance_ira,
);
export const selectTrustToTrustToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_trust_to_trust,
);
export const selectInternalGiftingManagedAccountsToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_internal_gifting_managed_accounts,
);
export const selectIntelledoxAndRedirectRemovalToggle = createSelector(
  getFeatureToggleState,
  (state) => state.intelledox_redirect_and_thresholds,
);
export const selectDocumentChecklistToggle = createSelector(
  getFeatureToggleState,
  (state) => state.doc_checklist_inheritance,
);
export const selectMultiInheritanceToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_multi_inheritance,
);
export const selectMultiInheritanceEstateToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_multi_inheritance_estate,
);
export const selectInheritanceSaveDraftToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_save_draft,
);
export const selectInheritanceSaveDraftInternalToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_save_draft_internal,
);
export const selectInheritanceNewTermsToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_new_terms,
);

export const selectMinorCO0Toggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_minor,
);

export const selectInheritanceCO0Toggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_inheritance,
);

export const selectInternalTransferCO0Toggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_internal_transfers,
);

export const selectCO0UploadToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_upload,
);

export const selectGiftingCO0Toggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_gifting,
);

export const selectDivorceToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_divorce,
);

export const selectGiftingAdvisedAccountsToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_gifting_advised_accounts,
);

export const selectItMultiReceivingToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_it_multi_receiving,
);

export const selectMultiTransactionsCrewToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_multi_transactions_crew,
);

export const selectRecipientValidationToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_account_validation,
);

export const selectFeatureTogglesLoaded = createSelector(
  getFeatureToggleState,
  (state) => state.togglesLoaded,
);

export const selectInheritanceVCDToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_vcd,
);

export const selectProspectToAuthFirstToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_prospect_to_auth_first,
);

export const selectL8ItwUploadToggle = createSelector(
  getFeatureToggleState,
  (state) => state.l8_itw_upload,
);

export const selectVCOrgToOrgToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_vc_org_to_org,
);

export const selectNonVCOrgTransferToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_non_vc_org_transfer,
);

export const selectDocumentUploadMFEToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_document_upload_mfe,
);
export const selectOrgAsBeneToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_org_as_bene,
);

export const selectMOGiftingToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_mo_gifting,
);

export const selectInheritanceIndividualJointToTrustToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_individual_joint_to_trust,
);

export const selectInheritanceRestrictDupTransactionsToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_restrict_dup_transactions,
);

export const selectInheritanceDecedentSecurityToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_decedent_security,
);

export const selectChecklistGetStartedToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_checklist_get_started,
);

export const selectCwpTermsW9RedesignToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_terms_w9_redesign,
);

export const selectCwpMultiItMoToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_multi_it_mo,
);

export const selectInheritanceAdvisedClientWarningsToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_advised_client_warnings,
);

export const selectCwpInheritanceSaveStateToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_inheritance_save_state,
);

export const selectCwpMinorSaveDraftToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_minor_save_draft,
);

export const selectCwpCashPlusSweepTransferToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_cash_plus_sweep_transfer,
);

export const selectCwpBuySellHomeUrlRoutingToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_buy_sell_home_url_routing,
);

export const selectViadocShadowModeToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_viadoc_shadow_mode,
);
